<template>
  <div class="bg2">
    <!-- <Header title="搜索" background="#ffffff"></Header> -->
    <div class="head"  @click='stop'>
      <div class="searchBox">
        <el-input
          placeholder="请输入想要的商品"
          clearable
          v-model="value"
          class="input-with-select"
        >
          <el-select
            v-model="select"
            popper-class="search"
            slot="prepend"
            @change="change"
          >
            <el-option label="商品" value="1"></el-option>
            <el-option label="链接" value="2"></el-option>
          </el-select>
        </el-input>
        <div class="searchBtn" @click="search">搜索</div>
      </div>
    </div>

    <div class="result">
      <div class="menu flex-between">
        <van-dropdown-menu active-color="#FD0212" >
          <van-dropdown-item @open='stop' v-model="value1" :options="option1" />
        </van-dropdown-menu>
        <span  @click='stop'>新上市</span>
        <div class="flex-center" @click="selectBox = !selectBox">
          <span>筛选</span>
          <!-- <img class="selectImg" src="../../assets/home/shaixuan@2x.png" alt=""> -->
          <img
            class="selectImg"
            src="../../assets/home/shaixuan@2x (2).png"
            alt=""
          />
        </div>
      </div>
      <div class="simple-scroll-list-out">
        <simple-scroll-list>
          <div class="list" v-for="item in 7" :key="item">
            <img src="../../assets/home/pic@2x (2).png" alt="" />
            <h5>女生卫撒旦撒旦撒旦asdasd撒旦撒旦撒飒飒打撒打撒衣连帽拼接款</h5>
            <p>¥378</p>
          </div>
        </simple-scroll-list>
        <searchBox v-if="selectBox" class="mengceng"></searchBox>
      </div>
    </div>
    <div class="historyBox" v-if="false">
      <div class="history">
        <p>搜索历史</p>
        <div>
          <span v-for="(item, index) in historyArr" :key="index">
            {{ item }}</span
          >
        </div>
      </div>
      <div class="history">
        <p>大家都在搜</p>
        <div>
          <span v-for="(item, index) in 5" :key="index"> {{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SimpleScrollList from "../../components/SimpleScrollList.vue";
import searchBox from "./selectBox";
export default {
  name: "",
  data() {
    return {
      selectBox: false,
      value: "",
      select: "1",
      historyArr: [],
      value1: 0,
      value2: "a",
      option1: [
        { text: "综合", value: 0 },
        { text: "价格降序", value: 1 },
        { text: "价格升序", value: 2 },
      ],
	  form: {
	    lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
	    page: 0, // 必选 请求数据页码
	    condition: {
	      categoryId: 0, // 商品分类ID。若不指定分类则传0
	      floor: 0, // 分类层级
	      orderField: "", // 排序的字段。默认传空字符串，按销量排序：sale；按价格排序：price
	      priceOrder: "", // 价格排序方向。升序：up；降序：down
	      isRecommend: null, // 是否为精品推荐。是：true；否：false。
	      isHot: null, // 是否为热卖。是：true；否：false。
	      isNew: null, // 是否为新品。是：true；否：false。
	    }, // 必选 搜索条件
	  },
    };
  },
  components: {
    searchBox,
    SimpleScrollList,
  },
  computed: {},
  mounted() {
	this.getList()
    let arr = JSON.parse(localStorage.getItem("history"));
    if (arr) {
      this.historyArr = arr;
    } else {
      this.historyArr = [];
    }
  },
  methods: {
    change(e) {
      console.log(e);
    },
    stop(){
      console.log('111')
	  this.selectBox = false
    },
    search() {
      let arr = [...this.historyArr];
      console.log(arr);
      if (arr.length) {
        arr.unshift(this.value);
        let newArr = arr.slice(0, 5);
        localStorage.setItem("history", JSON.stringify(newArr));
      } else {
        arr.unshift(this.value);
        localStorage.setItem("history", JSON.stringify(arr));
      }
    },
	getList(id, floor) {
	  if (id && floor) {
	    this.form.page = 1;
	    this.form.lastId = 0;
	    this.form.condition.categoryId = id;
	    this.form.condition.floor = floor;
	    this.list = [];
	    this.loading = true;
	    this.finished = false;
	  }
	
	  this.$post({
	    url: "/portal/Shop",
	    module: "Goods",
	    interface: "1001",
	    data: this.form,
	  }).then((res) => {
	    // console.log("商品列表", res);
	    this.form.lastId = res.lastId;
	    this.form.page++;
	    this.finished = res.currentPage >= res.lastPage;
	    this.list = this.list.concat(res.list);
	    this.loading = false;
	  });
	},
  },
};
</script>

<style lang='less' scoped>
.head {
  height: 44px;
  background: #ffffff;
  padding: 0 16px;
}
.searchBox {
  display: flex;
  align-items: center;
}
/deep/ .el-input-group {
  height: 30px;
  background: #f7f7f7;
  border-radius: 15px;
  width: 80%;
}
/deep/ .el-input-group__append,
/deep/ .el-input-group__prepend {
  background-color: transparent;
  border: none;
  width: 50px;
  padding: 0;
  padding-left: 15px;
}
/deep/ .el-input__inner {
  background-color: transparent;
  border: none;
  padding-left: 15px;
}

.searchBtn {
  width: 56px;
  height: 30px;
  background: #fd0212;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #ffffff;
  margin-left: 5px;
}
.history {
  padding: 0 16px;
  p {
    color: #999999;
    font-size: 12px;
    height: 50px;
    line-height: 50px;
  }
  div {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    span {
      padding: 8px 24px;

      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
      font-size: 14px;
      margin-right: 15px;
      margin-bottom: 15px;
    }
  }
}
.bg2 {
  flex-direction: column;
  display: flex;
  height: 100vh;
}

.simple-scroll-list-out {
  position: relative;
  height: calc(100% - 49px);

  .simple-scroll-list {
    padding: 0 16px;
  }

  /deep/.list-inner {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
  }

  .mengceng {
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.55);
    width: 100%;
  }

  .list {
    font-size: 14px;
    margin-top: 16px;
    img {
      width: 164px;
      height: 164px;
    }
    h5 {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      width: 160px;
      margin-top: 10px;
    }
    p {
      color: #fd0212;
      line-height: 30px;
    }
  }
}
.result {
  flex: 1;
  overflow: hidden;
  .menu {
    background-color: #fff;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 30px;
  }
}

.selectImg {
  width: 26px;
  height: 26px;
}
</style>
